import React, { useMemo } from 'react'
import { Form, Formik } from 'formik'
import FormikTextField from '@components/Formik/FormikTextField'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { FORM_ERRORS_MAPPING } from '../../../mappings'
import Dialog from '@mui/material/Dialog'
import { DialogTitle } from '@mui/material'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import FormikSwitcher from '@components/Formik/FormikSwitcher'

interface OrderNoteFormData {
  content: string
  replyToMe: boolean
}
interface Props {
  onSubmit(values: OrderNoteFormData): Promise<void>
  onCancel(): void
  initialValues?: OrderNoteFormData | null
}
const OrderNoteForm: React.FC<Props> = ({ onSubmit, onCancel, initialValues }) => {
  const { t } = useTranslation()
  const schema = useMemo(
    () => yup.object().shape({ content: yup.string().required(FORM_ERRORS_MAPPING(t, 'valueIsRequired')) }),
    [t]
  )
  return (
    <div>
      <Formik<OrderNoteFormData>
        initialValues={initialValues || { content: '', replyToMe: false }}
        validationSchema={schema}
        onSubmit={async (values, formikHelpers) => {
          await onSubmit(values)
          formikHelpers.resetForm()
        }}
        enableReinitialize
      >
        {({ values, handleSubmit }) => (
          <Dialog open={true} onClose={onCancel} maxWidth='md'>
            <DialogTitle>Add a note</DialogTitle>
            <DialogContent className='w-400 max-w-full' dividers>
              <Form>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <FormikTextField
                      name='content'
                      label=''
                      placeholder={t('placeholder.notes', 'Notes')}
                      minRows={1}
                      maxRows={5}
                      multiline
                      hideError
                    />
                  </Grid>
                </Grid>
              </Form>
            </DialogContent>
            <DialogActions>
              <div className='flex flex-1 justify-start pl-20'>
                <FormikSwitcher
                  name={'replyToMe' as keyof OrderNoteFormData}
                  size='small'
                  formControlProps={{
                    label: <span>Reply to me</span>,
                    control: null,
                  }}
                />
              </div>
              <Button variant='outlined' color='primary' size='medium' onClick={onCancel}>
                {t('button.cancel', 'Cancel')}
              </Button>
              <Button
                variant='contained'
                color='secondary'
                size='medium'
                type='submit'
                onClick={() => handleSubmit()}
                disabled={!values.content}
              >
                {t('button.submit', 'Submit')}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </div>
  )
}

export default OrderNoteForm
